
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/[slug]",
      function () {
        return require("private-next-pages/page/[subdomain]/[slug].tsx");
      }
    ]);
  